module.exports = __webpack_public_path__ + "img/drug-28.5dcbbb2b.png";